import { DependentResponse } from '../types/en-us'
import { DependenteResposta } from '../types/pt-br'

class GetIsMinorDependent {
  toDomain(data: DependenteResposta): DependentResponse {
    return {
      isMinorDependent: data?.menorIdade,
    }
  }
}

export default new GetIsMinorDependent()
